export const hasQueryOnString = ({
  str,
  query,
}: {
  str: string;
  query: string;
}): boolean => new RegExp(query, "i").test(str);
